import styled from "styled-components";

export const AddRelatedContactContainer = styled.div`
  width: 500px;
  min-height: 450px;
  padding: 3.5rem;
  display: flex;
  flex-direction: column;
`

export const AddRelatedContactTitle = styled.div`
  font-size: 16px;
  text-align: center;
`

export const AddRelatedContactContent = styled.div`
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const AddRelatedContactContentField = styled.div`

`

export const AddRelatedContactAction = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 3rem;
`